// src/init/routers.js
import { createWebHashHistory, createRouter } from "vue-router";
import store from "../../store/index";

const init = function () {
  const modulesFiles = require.context("../pages", true, /\.vue$/);

  const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    // 动态导入，生成独立 chunk
    const componentLoader = () => import(
      /* webpackChunkName: "page-[request]" */
      `../pages/${moduleName}.vue`
    );
    const routerData = {
      name: moduleName,
      component: componentLoader,
      meta: {
        title: moduleName.split('/').pop() || '未知页面',
      },
    };
    let path = "/" + moduleName.toLowerCase();
    if (moduleName.includes('/$')) {
      const mnarr = moduleName.split('/');
      const lastna = mnarr[mnarr.length - 1];
      const paramsname = lastna.replace('$', '');
      mnarr[mnarr.length - 1] = ":" + paramsname;
      path = "/" + mnarr.join('/');
    }
    routerData.path = path;
    modules[moduleName] = routerData;
    return modules;
  }, {});

  const routers = [
    { path: '/', redirect: '/dashboard/index' },
    ...Object.values(modules),
  ];

  const router = createRouter({
    history: createWebHashHistory(),
    routes: routers,
  });

  // 路由权限守卫（增强：超级管理员直接放行）
  router.beforeEach((to, from, next) => {
    const user = store.state?.user?.user;
    const permissions = store.state?.user?.permissions || [];
    // 超级管理员拥有所有权限
    if (user && user.role === 'super_admin') {
      next();
      return;
    }
    if (to.meta && to.meta.permission) {
      if (!permissions.includes(to.meta.permission)) {
        next('/');
        return;
      }
    }
    next();
  });

  return router;
};

export default {
  init,
};